/* src/app/warehousing/pages/product-groups/product-groups.component.scss */
/*# sourceMappingURL=product-groups.component.css.map */
